import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../../ReducerRegister";
import BatchService from "../../../../services/screens/admin/unit/BatchService";
import { ActionTypes } from "../../../actionTypes/screens/admin/unit/BatchExportActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import * as Helper from "../../../../utils/Helper";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.unit.batchexport;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            BatchService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (vo, data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        vo,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unitTypeList: null,
    unitDataList: [],
    sectionId: null,
    maxOrder: 0,
    data: null,
    title: "",
    unitType: "",
    duration: null,
    editUnitId: null,
    showErrors: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { vo, data }) => {
    const { edit, defaultTitle } = vo;
    const { section, unitTypeList, maxOrder } = data;
    let { title, units } = section || {};
    let unitDataList = [];
    if (units) {
        for (let i = 0; i < units.length; ++i) {
            let unit = units[i];
            unitDataList.push({...unit, data: JSON.parse(unit.data)});
        }
    } else if (vo.units) {
        for (let i = 0; i < vo.units.length; ++i) {
            let unit = vo.units[i];
            unitDataList.push({...unit});
        }
    }
    return { ...state, title: (title || defaultTitle),
             sectionId: (section ? section.id : null),
             maxOrder: maxOrder,
             unitTypeList: unitTypeList.filter(item => item.enabled === true || item.id === 'PSSO1'),
             unitDataList: unitDataList};
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
